import './App.css';
import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Main from './Sites/main';  
import Account from './Sites/Account';
import Cart from './Sites/Cart';
import Products from './Sites/Products';
import Checkout from './Sites/Checkout';
import Item from './Sites/Item';
import { CheckoutProvider } from './Context/CheckoutContext';
import Overview from './Sites/Overview';
import { AuthProvider } from './Context/AuthProvider';
import { CartProvider } from './Context/CartProvider';
import ResetPassword from './Components/Account/ResetPassword';
import PaymentReview from './Sites/PaymentReview';
import CompanyProducts from './Sites/CompanyProducts';
import OrderConfirmation from './Components/Checkout/OrderConfirmation';
import Infos from './Sites/Infos';
import TestPayment from './Sites/TestPayment';
import ThankYou from './Sites/ThankYou';
import Contact from './Sites/Contact';
import About from './Sites/About';
import Impressum from './Sites/Impressum';
import Sendback from './Sites/Sendback';
import ProductType from './Sites/ProductType';
import Services from './Sites/Services';
import Units from './Sites/Units';
import S200 from '../src/data/S200';
import S300 from '../src/data/S300';
import S280 from '../src/data/S280';
import S380 from '../src/data/S380';
import X5 from '../src/data/X5';
import X6 from '../src/data/X6';
import X9 from '../src/data/X9';
import RXDC from '../src/data/RXDC';

function App() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [analyticsAllowed, setAnalyticsAllowed] = useState(false);
  const [adsAllowed, setAdsAllowed] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setShowCookieBanner(true);
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookieConsent", JSON.stringify({ analytics: true, ads: true }));
    setAnalyticsAllowed(true);
    setAdsAllowed(true);
    setShowCookieBanner(false);
  };

  const handleCustomize = () => {
    setShowCustomize(true);
    setShowCookieBanner(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem("cookieConsent", JSON.stringify({ analytics: analyticsAllowed, ads: adsAllowed }));
    setShowCustomize(false);
  };

  return (
    <AuthProvider>
      <CartProvider>
        <CheckoutProvider>
          <div className="App">
            {/* Routes */}
            <Routes>
              <Route path='/' element={<Main/>}/>
              <Route path='/termekek/:category' element={<Products/>}/> 
              <Route path='/termekek/:category/:subcategory' element={<Products/>}/>         
              <Route path='/gyartok/:company' element={<CompanyProducts/>}/>
              <Route path='/termek/:category/:subcategory/:name/:id' element={<Item/>}/>
              <Route path='/fiok' element={<Account/>}/>
              <Route path='/kosar' element={<Cart/>}/>
              <Route path='/fizetes/szallitas' element={<Checkout/>}/>
              <Route path='/fizetes/osszegzes' element={<Overview/>}/>
              <Route path='/jelszovisszaallitas/:token' element={<ResetPassword/>}/>
              <Route path='/fizetes-visszaigazolas' element={<PaymentReview/>}/>
              <Route path='/rendeles-visszaigazolas' element={<OrderConfirmation/>}/>
              <Route path='/fizetes-szallitas' element={<Infos/>}/>
              <Route path='/teszt-fizetes' element={<TestPayment/>}/>
              <Route path='/koszonjuk' element={<ThankYou/>}/>
              <Route path='/kapcsolat' element={<Contact/>}/>
              <Route path='/rolunk' element={<About/>}/>
              <Route path='/impresszum' element={<Impressum/>}/>
              <Route path='/visszakuldes' element={<Sendback/>}/>
              <Route path='/termek-csoport' element={<ProductType/>}/>
              <Route path='/szolgaltatasok' element={<Services/>}/>
              <Route path='/termek/stern-weber-fogaszati-kezeloegysegek/kezeloegysegek/s200/1' element={<Units productData={S200}/>}/>
              <Route path='/termek/stern-weber-fogaszati-kezeloegysegek/kezeloegysegek/s300/31' element={<Units productData={S300}/>}/>
              <Route path='/termek/stern-weber-fogaszati-kezeloegysegek/kezeloegysegek/s280trc/34' element={<Units productData={S280}/>}/>
              <Route path='/termek/stern-weber-fogaszati-kezeloegysegek/kezeloegysegek/s380trc/35' element={<Units productData={S380}/>}/>
              <Route path='/termek/fogaszati-rontgenberendezesek/intraoralis-rontgen/rxdc-extend/40' element={<Units productData={RXDC}/>}/>
              <Route path='/termek/fogaszati-rontgenberendezesek/digitalis-panoramarontgen/x5/44' element={<Units productData={X5}/>}/>
              <Route path='/termek/fogaszati-rontgenberendezesek/digitalis-panoramarontgen/proxima-x6/143' element={<Units productData={X6}/>}/>
              <Route path='/termek/fogaszati-rontgenberendezesek/digitalis-panoramarontgen/x9-pro/46' element={<Units productData={X9}/>}/>
            </Routes>

            {/* Cookie Banner */}
            {showCookieBanner && (
              <div style={{
                position: "fixed",
                bottom: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                background: "#fff",
                borderRadius: "12px",
                padding: "20px 25px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1000,
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                maxWidth: "90%"
              }}>
                <p style={{ marginBottom: "15px", fontSize: "14px", color: "#333", textAlign: "center" }}>
                  Weboldalunk sütiket használ a felhasználói élmény javításához. Mely sütiket engedélyezi?
                </p>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    onClick={handleAcceptAll}
                    style={{
                      background: "linear-gradient(90deg, #4CAF50, #45A049)",
                      color: "white",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "600",
                      transition: "0.3s"
                    }}
                  >
                    Összes elfogadása
                  </button>
                  <button
                    onClick={handleCustomize}
                    style={{
                      background: "#f0ad4e",
                      color: "white",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "600",
                      transition: "0.3s"
                    }}
                  >
                    Testreszabás
                  </button>
                </div>
              </div>
            )}

            {/* Customize Modal */}
            {showCustomize && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                  animation: "fadeIn 0.3s"
                }}
              >
                <div style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "12px",
                  width: "350px",
                  maxWidth: "90%",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                  textAlign: "center",
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  animation: "slideIn 0.3s"
                }}>
                  <h2 style={{ marginBottom: "15px", color: "#333" }}>Süti beállítások</h2>
                  <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
                    Válassza ki, mely sütiket engedélyezi.
                  </p>
                  <div style={{ textAlign: "left", marginBottom: "20px" }}>
                    <label style={{ display: "block", marginBottom: "10px", fontSize: "14px" }}>
                      <input
                        type="checkbox"
                        checked={analyticsAllowed}
                        onChange={(e) => setAnalyticsAllowed(e.target.checked)}
                        style={{ marginRight: "8px" }}
                      />
                      Analitikai sütik engedélyezése
                    </label>
                    <label style={{ display: "block", fontSize: "14px" }}>
                      <input
                        type="checkbox"
                        checked={adsAllowed}
                        onChange={(e) => setAdsAllowed(e.target.checked)}
                        style={{ marginRight: "8px" }}
                      />
                      Hirdetési sütik engedélyezése
                    </label>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                    <button
                      onClick={handleSavePreferences}
                      style={{
                        background: "linear-gradient(90deg, #4CAF50, #45A049)",
                        color: "white",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: "600",
                        transition: "0.3s"
                      }}
                    >
                      Beállítások mentése
                    </button>
                    <button
                      onClick={() => setShowCustomize(false)}
                      style={{
                        background: "#f44336",
                        color: "white",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: "600",
                        transition: "0.3s"
                      }}
                    >
                      Mégse
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </CheckoutProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;